import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const BillingPage = lazy(() => import('./pages/billingPage'))
export const billingRoutes = () => {
  return (
    <>
      <Route path={pageUrl.billing} element={<BillingPage />} />
    </>
  )
}
